import React from 'react';
import { Text } from '@usealloy/component-library';
import type { TFunction } from 'i18next';

import { actionTypes } from './constants';
import type { BlockedAction } from '../types';


interface Props {
  blockedActions: BlockedAction[];
  isJourneyApplicationPage?: boolean;
  summary: any;
  t: TFunction;
}

function getBlockingReason(
  blockedActions: BlockedAction[],
  blockedActionType: BlockedAction['blocked']['action_type'],
  summary: any,
): string {
  const blockedAction = blockedActions.find(
    action => action.blocked.action_type === blockedActionType,
  );

  if (blockedAction?.blocking) {
    return summary.services[blockedAction.blocking.action_name] ?? 'default';
  }

  return 'default';
}

export function PartialExplanation(props: Props) {
  let blockedActionType: BlockedAction['blocked']['action_type'] = actionTypes.service;
  const {
    blockedActions,
    isJourneyApplicationPage,
    summary,
    t,
  } = props;

  if (
    blockedActions.find(
      blockedAction => blockedAction.blocked.action_type === actionTypes.tag,
    )
  ) {
    blockedActionType = 'tag';
  }

  const blockingReason = getBlockingReason(blockedActions, blockedActionType, summary);

  return (
    <Text as="span" size={2}>
      {t(
        `features.evaluations.results.partial.explanation.${blockedActionType}.${blockingReason}`,
        { evaluationOrApplication: isJourneyApplicationPage ? 'Application' : 'Evaluation' },
      ) as unknown as React.ReactNode}
    </Text>
  );
}
